module.exports = __webpack_public_path__ + "2c441990f8585e08047770c9be18d3.png";